/* React */
import React from "react";

/* Utils */
import { extractUniqueTLs } from "src/utils/helper/treatment-patterns/transformTreatmentData";

/* Components */
import FilterItem from "src/components/chart-wrapper/toolbar/options/horizontal-boxplot-options/treatment-line-filter/filter-container/filter-item/FilterItem";

/* Stylesheet */
import styles from "./FilterContainer.module.scss";

/* Interfaces */
import { BoxplotProps } from "src/shared/interfaces/Boxplot";

interface FilterContainerProps {
  data: BoxplotProps[];
  selectedTLs: string[];
  handleSelectedTLs: (treatmentLines: string[]) => void;
}

const FilterContainer: React.FC<FilterContainerProps> = ({
  data,
  selectedTLs,
  handleSelectedTLs,
}) => {
  const availableTLs = extractUniqueTLs(data);

  const handleToggle = (treatmentLine: string) => {
    const isActive = selectedTLs.includes(treatmentLine);
    const updatedTLs = isActive
      ? selectedTLs.filter((t) => t !== treatmentLine)
      : [...selectedTLs, treatmentLine];

    handleSelectedTLs(updatedTLs);
  };

  return (
    <div className={styles.filter_container}>
      <div className={styles.label}>TL-Filter</div>
      <div className={styles.wrapper_container}>
        {availableTLs.map((treatmentLine, index) => {
          return (
            <FilterItem
              key={index}
              treatmentLine={treatmentLine}
              isActive={selectedTLs.includes(treatmentLine)}
              onClick={handleToggle}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FilterContainer;
